export default ({ request }) => ({
  sampleStockSellReturnListApi(data = {}) {
    return request({
      url: '/samplemanage/billStockSellMainReturn/list',
      method: 'post',
      data
    })
  },
  sampleStockSellReturnDetailApi(data = {}) {
    return request({
      url: '/samplemanage/billStockSellMainReturn/detail',
      method: 'post',
      data
    })
  },
  sampleStockSellReturnSavalApi(data = {}) {
    return request({
      url: '/samplemanage/billStockSellMainReturn/save',
      method: 'post',
      data
    })
  },
  sampleStockSellReturnDelApi(data = {}) {
    return request({
      url: '/samplemanage/billStockSellMainReturn/del',
      method: 'post',
      data
    })
  },
  sampleStockSellReturnAudit(data = {}) {
    return request({
      url: '/samplemanage/billStockSellMainReturn/audit',
      method: 'post',
      data
    })
  }
})
